import {RichTextField} from '@prismicio/client'
import {PrismicRichText} from '@prismicio/react'
import {Icon} from 'src/common/Icon'

const GRID_CLASSES = [
  'inset-[-3px] top-[-1px]',
  'ml-[1px] right-[-3px] top-[-2px] scale-x-[-1]',
  'mt-[1px] bottom-[-2px] left-[-3px] rotate-[180deg] scale-x-[-1]',
  'ml-[1px] mt-[1px] bottom-[-2px] right-[-3px] rotate-[180deg]',
]

const BORDER_CLASSES = ['', 'ml-[-1px]', 'mt-[-1px]', 'ml-[-1px] mt-[-1px]']

type BadgeCellProps = {
  badgeCell: RichTextField
  index: number
}

// Helper function to render badge cells
export const BadgeCell = ({badgeCell, index}: BadgeCellProps) => (
  <div
    className={`relative flex flex-col items-center justify-center rounded-[5px] border border-green-light bg-green-dark ${BORDER_CLASSES[index]}`}
  >
    <Icon name="corner" className={`absolute h-[7px] w-[8.5px] text-[#FDFFF9] ${GRID_CLASSES[index]}`} />
    <div className="flex flex-col items-center justify-center gap-2">
      <PrismicRichText
        field={badgeCell}
        components={{
          paragraph: ({children}) => (
            <p className="text-[8px] font-semibold uppercase leading-[normal] tracking-[.48px] text-moss-grey-100">
              {children}
            </p>
          ),
          strong: ({children}) => (
            <span className="text-[12px] font-semibold uppercase leading-[normal] tracking-[.72px] text-green-neon">
              {children}
            </span>
          ),
          image: ({node}) => <img className="h-[11px] w-[67px]" src={node.url} alt={node.alt || ''} />,
        }}
      />
    </div>
  </div>
)
